import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["page", "dotsContainer", "navigation"]
  static values = {
    index: { type: Number, default: 0 },
    autoplay: { type: Boolean, default: false },
    interval: { type: Number, default: 5000 },
    itemsPerPage: { type: Number, default: 6 }
  }

  connect() {
    this.showPage(this.indexValue)
    this.createDots()
    this.toggleNavigation()

    if (this.autoplayValue && this.pageTargets.length > 1) {
      this.startAutoplay()
    }
  }

  disconnect() {
    this.stopAutoplay()
  }

  next() {
    this.stopAutoplay()
    this.indexValue = (this.indexValue + 1) % this.pageTargets.length
    this.showPage(this.indexValue)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  previous() {
    this.stopAutoplay()
    this.indexValue = (this.indexValue - 1 + this.pageTargets.length) % this.pageTargets.length
    this.showPage(this.indexValue)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  goToPage(event) {
    this.stopAutoplay()
    const index = parseInt(event.currentTarget.dataset.index)
    this.indexValue = index
    this.showPage(this.indexValue)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  showPage(index) {
    this.pageTargets.forEach((page, i) => {
      if (i === index) {
        page.classList.remove("hidden")
        page.style.opacity = "0"
        // Trigger animation
        setTimeout(() => {
          page.style.opacity = "1"
        }, 10)
      } else {
        page.classList.add("hidden")
      }
    })

    this.updateDots(index)
  }

  createDots() {
    if (!this.hasDotsContainerTarget) return
    if (this.pageTargets.length <= 1) return

    this.dotsContainerTarget.innerHTML = ""

    this.pageTargets.forEach((_, index) => {
      const dot = document.createElement("button")
      dot.classList.add("slider-dot")
      dot.dataset.index = index
      dot.dataset.action = "click->services-slider#goToPage"
      dot.setAttribute("aria-label", `Ir a página ${index + 1}`)

      if (index === this.indexValue) {
        dot.classList.add("active")
      }

      this.dotsContainerTarget.appendChild(dot)
    })
  }

  updateDots(activeIndex) {
    if (!this.hasDotsContainerTarget) return

    const dots = this.dotsContainerTarget.querySelectorAll(".slider-dot")
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add("active")
      } else {
        dot.classList.remove("active")
      }
    })
  }

  toggleNavigation() {
    if (!this.hasNavigationTarget) return

    // Hide navigation if there's only one page or less
    if (this.pageTargets.length <= 1) {
      this.navigationTarget.style.display = "none"
    } else {
      this.navigationTarget.style.display = "flex"
    }
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.indexValue = (this.indexValue + 1) % this.pageTargets.length
      this.showPage(this.indexValue)
    }, this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    }
  }
}
